import { render, staticRenderFns } from "./EmployeeSelect.vue?vue&type=template&id=06d28a94&"
import script from "./EmployeeSelect.vue?vue&type=script&lang=js&"
export * from "./EmployeeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports